export interface DynamicPricingAdjustmentData {
  adjustmentStartTime: Date;
  adjustmentEndTime: Date;
  adjustmentPrice: number;
  activePrice: boolean;
}
